export const groupBy = <T, Type>(
  data: T[],
  getType: (item: T, index: number) => Type,
  getMaxItems: (type: Type) => number
) => {
  const result: {
    type: Type;
    id: string;
    children: T[];
  }[] = [];

  let i = 0;
  while (i < data.length) {
    const current = data[i];
    const lastItem = result[result.length - 1];
    if (current == null || getType(current, i) == null) {
      i++;
      continue;
    }
    if (
      lastItem == null ||
      getType(current, i) !== lastItem.type ||
      lastItem.children.length >= getMaxItems(lastItem.type)
    ) {
      result.push({
        id: String(result.length),
        type: getType(current, i),
        children: [current],
      });
      i++;
      continue;
    }
    lastItem.children.push(current);
    i++;
  }
  return result;
};

export const groupNItems = <T>(data: T[], n: number) => {
  return groupBy(
    data,
    () => 0,
    () => n
  );
};
